import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { updateNewRate } from "../../../services/updateNewRate";
import { convertAge } from "../../../utils/convertAge";

export const checkPriceRange = (
  type: string,
  target: string,
  e: stdObject,
  params: stdObject,
) => {
  const {
    t,
    updateFunction,
    condPricesRates,
    pricesRates,
    setMsg2,
    setModalData2,
    logoutAction,
    closeMsg,
  } = params;
  const finalTarget = { target, goMenu: type };
  if (target === "CLI") {
    const ageValue = convertAge(e.NACCLI);

    const existsRange =
      Array.isArray(ageValue) && ageValue.length === 3
        ? condPricesRates.filter(
            (v: stdObject) =>
              e[v.CODTA0] === v.VALTA0 && ageValue[0] > v.VAL2TA0,
          )
        : [];
    if (existsRange.length > 0 && e.TARCLI !== existsRange[0].TARTA0) {
      const tar1 = pricesRates.find(
        (v: stdObject) => v.CODTAR === e.TARCLI,
      )?.NOMTAR;
      const tar2 = pricesRates.find(
        (v: stdObject) => v.CODTAR === existsRange[0].TARTA0,
      )?.NOMTAR;
      setMsg2("custom2");
      setModalData2({
        title: t("p.askUpdateClientePriceRate"),
        label: `${tar1}  >  ${tar2}`,
        buttons: [
          {
            label: t("p.update"),
            onClick: () => {
              updateNewRate(
                {
                  code: e.CODCLI,
                  name: e.NOMCLI,
                  web: e.WEBCLI,
                  rate: existsRange[0].TARTA0,
                },
                logoutAction,
              );
              updateFunction(
                { ...e, TARCLI: existsRange[0].TARTA0 },
                "",
                finalTarget,
              );
              closeMsg(2);
            },
            color: colors.orange,
          },
          {
            label: t("p.close"),
            onClick: () => {
              updateFunction(e, "", finalTarget);
              closeMsg(2);
            },
            color: colors.darkGrey,
          },
        ],
      });
      return true;
    }
  }
  updateFunction(e, "", finalTarget);
};
